"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarChangePriceOutputWidget = void 0;
var React = require("react");
var components_1 = require("@athena-portal/components");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var ExcessExplainedRenderers_1 = require("../../../components/modals/renderers/ExcessExplainedRenderers");
var PremiumOutputWidget_1 = require("../PremiumOutputWidget");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var PricingExplainedRenderers_1 = require("../../../components/modals/renderers/PricingExplainedRenderers");
var CarChangePriceOutputWidget = exports.CarChangePriceOutputWidget = /** @class */ (function (_super) {
    __extends(CarChangePriceOutputWidget, _super);
    function CarChangePriceOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderIfRefund = function () {
            var oldVehicleMake = _this.findOldVehicleProperty("make", _this.props.interaction.uistate.relativeInteractionId);
            var oldVehicleModel = _this.findOldVehicleProperty("model", _this.props.interaction.uistate.relativeInteractionId);
            var oldVehicleRegistrationNumber = _this.findOldVehicleProperty("registrationNumber", _this.props.interaction.uistate.relativeInteractionId);
            var vehicle = _this.props.interaction.vehicles[0];
            window.sessionStorage.setItem("oldCarVrn", oldVehicleRegistrationNumber);
            window.sessionStorage.setItem("oldCarMake", oldVehicleMake);
            window.sessionStorage.setItem("oldCarModel", oldVehicleModel);
            if (_this.props.interaction.factors.returnPremium > 0) {
                return (React.createElement("div", null,
                    React.createElement("div", { className: "replace-car-price" },
                        React.createElement("p", { className: "text-center d-inline" },
                            React.createElement("b", null, "Refund of")),
                        " ",
                        (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.returnPremium)),
                    React.createElement("p", { className: "text-center" },
                        "to ",
                        React.createElement("b", null,
                            "replace ",
                            oldVehicleMake,
                            ", ",
                            oldVehicleModel,
                            " (",
                            oldVehicleRegistrationNumber,
                            ") with ",
                            vehicle.make,
                            ", ",
                            vehicle.model,
                            " (",
                            vehicle.registrationNumber,
                            ")"))));
            }
            else if (_this.props.interaction.factors.additionalPremium > 0) {
                return (React.createElement("div", null,
                    React.createElement("div", { className: "replace-car-price" }, (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.additionalPremium)),
                    React.createElement("p", { className: "text-center" },
                        "to ",
                        React.createElement("b", null,
                            "replace ",
                            oldVehicleMake,
                            ", ",
                            oldVehicleModel,
                            " (",
                            oldVehicleRegistrationNumber,
                            ") with ",
                            vehicle.make,
                            ", ",
                            vehicle.model,
                            " (",
                            vehicle.registrationNumber,
                            ")"))));
            }
            else {
                return (React.createElement("div", null,
                    React.createElement("p", { className: "text-center font-weight-bold" }, "Good news, there is no extra cost for the change you made!")));
            }
        };
        _this.findOldVehicleProperty = function (propertyName, oldInteractionId) {
            if (_this.state.policies && _this.state.policies.length > 0) {
                for (var _i = 0, _a = _this.state.policies; _i < _a.length; _i++) {
                    var policy = _a[_i];
                    if (policy.interaction._id === oldInteractionId) {
                        return policy.interaction.vehicles[0][propertyName];
                    }
                }
            }
            return "";
        };
        _this.handleVoluntaryExcessChange = _this.handleVoluntaryExcessChange.bind(_this);
        return _this;
    }
    CarChangePriceOutputWidget.prototype.render = function () {
        if (this.state.policies && this.state.subscription) {
            return (React.createElement("div", { className: "mb-4" },
                React.createElement("div", { className: "top-section" },
                    React.createElement("div", { className: "panel" }, this.renderFirstMonthPrice()),
                    this.renderVoluntaryExcess())));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    ;
    CarChangePriceOutputWidget.prototype.renderFirstMonthPrice = function () {
        var neverHigherPeriodWording = this.getNeverHigherPeriodWording(this.props.interaction, this.props.interaction.uistate.subscriptionNeverHigher, this.state.policies);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "price", className: "text-center font-family-display font-weight-bold" }, this.renderIfRefund()),
            React.createElement("p", { className: "text-center mx-4 mb-2" },
                "Price could go up or down monthly.",
                React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Pricing explained" }, (0, PricingExplainedRenderers_1.renderPricingExplained)(this.props.interaction))),
            neverHigherPeriodWording,
            React.createElement("p", { className: "text-center mb-0" }, "All figures include Insurance Premium Tax.")));
    };
    ;
    CarChangePriceOutputWidget.prototype.renderVoluntaryExcess = function () {
        var interaction = this.props.engine.getInteraction();
        var vehicle = interaction.vehicles[0];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "panel" },
                React.createElement("div", { className: "text-center muli-bold-16-black pt-3 pb-3" }, "Excesses"),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("label", { className: "text-center pl-5 m-0" },
                        "Compulsory excess ",
                        React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Compulsory excess explained" }, (0, ExcessExplainedRenderers_1.renderCompulsoryExcessExplained)(vehicle.excesses))),
                    this.renderDriverCompulsoryExcess(interaction, vehicle)),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("label", { className: "text-center pl-5 mb-3" },
                        "Voluntary excess ",
                        React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Voluntary excess explained" }, (0, ExcessExplainedRenderers_1.renderVoluntaryExcessExplained)(vehicle.excesses))),
                    this.renderVoluntaryExcessBtns(vehicle)))));
    };
    CarChangePriceOutputWidget.prototype.renderDriverCompulsoryExcess = function (interaction, vehicle) {
        var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
        var vehicleDrivers = [];
        if (vehicle.driverIds) {
            vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); });
        }
        return vehicleDrivers.map(function (driver, index) {
            var driverCompExcess = driver.excesses.adExcess + vehicle.excesses.adExcess;
            var driverDescription = "additional driver";
            if (driver.personId === vehicle.mainDriverId) {
                driverDescription = "main driver";
            }
            return (React.createElement("div", { className: "text-center m-0 font-weight-extra-light", key: index }, "".concat(driver.firstName, " ").concat(driver.lastName, ", "),
                React.createElement("span", { className: "font-weight-semi-bold" },
                    driverDescription,
                    ":"), " \u00A3".concat(driverCompExcess)));
        });
    };
    CarChangePriceOutputWidget.prototype.renderVoluntaryExcessBtns = function (vehicle) {
        var _this = this;
        var excessAmounts = [0, 100, 200, 300, 400, 500];
        var btns = [];
        excessAmounts.forEach(function (amount, index) {
            var isChecked = amount === vehicle.excesses.voluntaryExcess;
            btns.push((React.createElement("div", { key: index, className: "col-4 mb-3" },
                React.createElement("div", { className: "btn-radio mx-2" },
                    React.createElement("input", { id: "excess".concat(vehicle.registrationNumber, "amount").concat(amount), name: "excess".concat(vehicle.registrationNumber), type: "radio", value: amount, "data-vehicle-index": vehicle.info.index, onChange: _this.handleVoluntaryExcessChange, checked: isChecked }),
                    React.createElement("label", { htmlFor: "excess".concat(vehicle.registrationNumber, "amount").concat(amount) }, "\u00A3".concat(amount))))));
        });
        return (React.createElement("div", { className: "voluntary-excess-btns row no-gutters mx-auto" }, btns));
    };
    CarChangePriceOutputWidget.prototype.handleVoluntaryExcessChange = function (event) {
        var amount = parseInt(event.target.value);
        var vehicleIndex = event.target.dataset.vehicleIndex;
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "].excesses.voluntaryExcess"), amount);
        this.executeEvent("change");
    };
    CarChangePriceOutputWidget.prototype.getNeverHigherPeriodWording = function (interaction, subscriptionNeverHigher, policies) {
        var constraintEndDate = null;
        if (services_1.productHelper.includesMotorProduct(policies) && interaction.vehicles) {
            constraintEndDate = (0, commonFunctions_1.convertDate)(interaction.vehicles[0].factors.constraintEndDate, "DD MMMM YYYY");
        }
        else if (services_1.productHelper.includesRentersProduct(policies) && interaction.realEstates) {
            constraintEndDate = (0, commonFunctions_1.convertDate)(interaction.realEstates[0].realEstateFactors.constraintEndDate, "DD MMMM YYYY");
        }
        var ending = (constraintEndDate) ?
            "until ".concat(constraintEndDate, ", based on your current details") :
            "for the following 3 months based on your current details.";
        return React.createElement("p", { className: "text-center mx-4" },
            "Guaranteed you won't pay more than",
            ' ',
            React.createElement("span", { className: "font-weight-bold" }, "".concat((0, commonFunctions_1.getAmountToDisplay)(subscriptionNeverHigher), "/mo")),
            ' ',
            ending);
    };
    CarChangePriceOutputWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CarChangePriceOutputWidget);
    return CarChangePriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
//# sourceMappingURL=CarChangePriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarChangePriceOutputWidget.js
// module id = 2595
// module chunks = 0